import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import Header from "../components/Header";
import Footer from "../components/Footer";
import CustomModal from "../components/CustomModal";

const MainLayout = () => {
    const [modalData, setModalData] = useState({
        show: false,
        title: "",
        contentType: ""
    });

    // Function to open modal
    const openModal = (title, contentType) => {
        setModalData({ show: true, title, contentType });
    };

    // Function to close modal
    const closeModal = () => {
        setModalData((prev) => ({ ...prev, show: false }));
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 800,
            once: false,
        });
    }, []);

    return (
        <>
            <Header openModal={openModal} />
            <main>
                <Outlet context={{ openModal }} />
            </main>
            <Footer />

            {/* WhatsApp Floating Button */}
            <a
                href="https://wa.me/9356579987?text=Hello%20I%20am%20interested%20in%20your%20products"
                className="whatsapp-float"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/whatsapp.svg"
                    alt="WhatsApp"
                />
            </a>

            {/* One common modal for the whole app */}
            <CustomModal
                show={modalData.show}
                onClose={closeModal}
                title={modalData.title}
                contentType={modalData.contentType}
                openModal={openModal}
            />
        </>
    );
};

export default MainLayout;
